var STORAGE_KEY = 'export_task';

/**
 * 从 localStorage 获取导出任务信息
 * @returns {Object|null} 导出任务信息对象或 null
 */
function getFromStorage() {
    try{
        var raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    }catch(e) {
        return null;
    }
}

/**
 * 将导出任务信息保存到 localStorage
 * @param {*} state 
 * @return {void}
 */
function saveToStorage(state) {
    try{
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
            taskId: state.taskId,
            status: state.status,
            show: state.show,
            progress: state.progress,
            downloadUrl: state.downloadUrl,
            startTime: state.startTime,
            statusUrl: state.statusUrl
        }))
    }catch(e) {}
}

/**
 * 清除 localStorage 中的导出任务信息
 * @return {void}
 */
function clearStorage() {
    localStorage.removeItem(STORAGE_KEY);
}

var state = {
    show: false,
    status: 'idle',
    progress: 0,
    timeText: '',
    downloadUrl: '',
    errorMsg: '',
    isExporting: false,
    startTime: null,
    taskId: null,
    exportChannel: null,
    statusUrl: ''
};

var mutations = {
    /**
     * 设置导出任务信息
     * @param {*} state 
     * @param {*} payload 
     */
    SET_EXPORT(state, payload) {
        Object.keys(payload).forEach(function(key) {
            if(key in state) {
                state[key] = payload[key];
            }
        })
    },
    /**
     * 清除重置导出任务信息
     * @param {*} state 
     */
    RESET_EXPORT(state) {
        state.show = false;
        state.status = 'idle';
        state.progress = 0;
        state.timeText = '';
        state.downloadUrl = '';
        state.errorMsg = '';
        state.isExporting = false;
        state.startTime = null;
        state.taskId = null;
        state.exportChannel = null;
        state.statusUrl = '';
        clearStorage();
    }
};

var actions = {
    setExport: function(ctx, payload) {
        ctx.commit('SET_EXPORT', payload);
        if(
            payload.taskId !== undefined ||
            payload.status !== undefined ||
            payload.show !== undefined
        ) {
            saveToStorage(Object.assign({}, ctx.state, payload))
        }
    },

    resetExport: function(ctx) {
        ctx.commit('RESET_EXPORT');
    },

    restoreExport: function(ctx) {
        var saved = getFromStorage();
        if (saved && saved.taskId && (saved.status === 'processing' || saved.status === 'completed')) {
            ctx.commit('SET_EXPORT', {
                taskId: saved.taskId,
                status: saved.status,
                show: saved.show,
                isExporting: saved.status === 'processing',
                progress: saved.progress || 0,
                downloadUrl: saved.downloadUrl || '',
                startTime: saved.startTime,
                statusUrl: saved.statusUrl || ''
            })
            return saved;
        }
        return null;
    }
}

export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions
}


// WEBPACK FOOTER //
// ./src/store/modules/export.js